import {Component, Input, OnInit} from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {UsersService} from '../../users/service/users.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-monthly-charges-tab',
  templateUrl: './monthly-charges-tab.component.html',
  styleUrls: ['./monthly-charges-tab.component.scss']
})
export class MonthlyChargesTabComponent extends BaseGeneralComponent implements OnInit {
  sectionId: string;
  selectedIndex: any;
  @Input() reportSection?: boolean;

  constructor(private userService: UsersService, private _Activatedroute: ActivatedRoute,) {
    super();
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }

  ngOnInit() {
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
  }

}
